import { useConversations } from '@/hooks/messaging'
import { useNavigate } from 'react-router-dom'
import { UserAvatar } from '@/components/UserAvatar'

export function ConversationsList() {
  const { data: conversations, isLoading, error } = useConversations()
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-muted-foreground">Loading conversations...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-destructive">Error loading conversations</div>
      </div>
    )
  }

  if (!conversations?.length) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-muted-foreground">No conversations yet</div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">Messages</h2>

      <div className="space-y-2">
        {conversations.map((conversation) => (
          <div
            key={conversation.id}
            className="cursor-pointer rounded-lg border p-4 transition-colors hover:bg-muted"
            onClick={() => navigate(`/messages/${conversation.id}`)}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex flex-1 gap-3">
                <UserAvatar
                  size="sm"
                  username={
                    conversation.last_message?.sender_username ??
                    `Proposal #${conversation.proposal_id}`
                  }
                />
                <div className="flex-1">
                  <div className="font-semibold">Proposal #{conversation.proposal_id}</div>
                  {conversation.last_message && (
                    <div className="mt-1 truncate text-sm text-muted-foreground">
                      <span className="font-medium">
                        {conversation.last_message.sender_username}:
                      </span>{' '}
                      {conversation.last_message.content}
                    </div>
                  )}
                  <div className="mt-1 text-xs text-muted-foreground">
                    {new Date(conversation.updated_at).toLocaleString()}
                  </div>
                </div>
              </div>

              {conversation.unread_count > 0 && (
                <span className="ml-2 rounded-full bg-primary px-2 py-1 text-xs font-semibold text-primary-foreground">
                  {conversation.unread_count}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
